import React, { Component } from 'react';
import PropTypes from 'prop-types';

import i18n from 'i18n-react';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

import BackImage from 'components/BackImage';

import DataHandler from 'config/DataHandler';

import { name, productLinks } from 'settings';

/**
 * @typedef {object} BackImageProps
 * @property {boolean} [blur] Blur the image
 * @property {boolean} [darken] Darken the image
 */

/**
 * BackImage
 *
 * Component for the purpose of displaying a background image
 *
 * @param {BackImageProps} props Props
 * @returns {JSX.Element} BackImage
 */
export default class MobileWarning extends Component {
  constructor(props) {
    super(props);

    this.state = {
      appId: 0,
    };
  }

  UNSAFE_componentWillMount() {
    DataHandler.matchAppId().then((app) => {
      this.setState({ appId: app });
    });
  }

  render() {
    const { appId } = this.state;

    return (
      <div>
        <div className="container__mobileButtons">
          <div className="backImage" />
          <div className="container__mobileButtons__holder">
            <h2>
              {i18n.translate('onMobile.header', {
                appName: name,
              })}
            </h2>
            <section>
              {i18n.translate('onMobile.body', {
                appName: name,
              })}
            </section>
            <h5>{i18n.translate('onMobile.benefits.header')}</h5>
            <ul>
              <li>{i18n.translate('onMobile.benefits.1')}</li>
              <li>{i18n.translate('onMobile.benefits.2')}</li>
              <li>{i18n.translate('onMobile.benefits.3')}</li>
            </ul>
            <div className="buttons">
              <a href={productLinks.ios}>
                <img src={apple} alt="App store" />
              </a>
              <a href={productLinks.android}>
                <img src={google} alt="Google Play" />
              </a>
            </div>
            <hr />
            <span>
              {'App: '}
              {appId}
            </span>
          </div>
        </div>
      </div>
    );
  }
}

BackImage.propTypes = {
  blur: PropTypes.bool,
  darken: PropTypes.bool,
};
